import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = { id: "main-content-port" }
const _hoisted_4 = {
  class: "fl w80",
  id: "RoomsContainer"
}
const _hoisted_5 = {
  key: 0,
  class: "kakugo w100",
  style: {"height":"120px","top":"0","z-index":"10"}
}
const _hoisted_6 = {
  class: "ofh w100 fl",
  style: {"margin-top":"25px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", {
  class: "fs20 ls1 fl mr40",
  style: {"margin-left":"80px","margin-top":"24px"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, "スグIN管理画面")
], -1)
const _hoisted_8 = { class: "fr mt40" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: ""
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "調整ページが見つかりませんでした。", -1)
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 3,
  class: "roomTableContentWrapper pad20",
  id: "roomTableContentWrapper"
}
const _hoisted_17 = { class: "w100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = { class: "fl w20 centered" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs20 pad20 mt40" }, "今日の予定", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: ""
}
const _hoisted_23 = {
  key: 1,
  class: ""
}
const _hoisted_24 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "予定がありません", -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 2,
  class: "llgreyBg"
}
const _hoisted_28 = { class: "w100 pad10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_InstantRoomAllSwitcher = _resolveComponent("InstantRoomAllSwitcher")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_OneInstantRoom = _resolveComponent("OneInstantRoom")!
  const _component_OneEventRoomContent = _resolveComponent("OneEventRoomContent")!
  const _component_ModalRoomMembersLink = _resolveComponent("ModalRoomMembersLink")!
  const _component_PublicLinkModal = _resolveComponent("PublicLinkModal")!
  const _component_CreateFromDraftModal = _resolveComponent("CreateFromDraftModal")!
  const _component_GoAvailableScheduleModal = _resolveComponent("GoAvailableScheduleModal")!
  const _component_ChooseRoomTypeModal = _resolveComponent("ChooseRoomTypeModal")!
  const _component_ModalCancelAppointment = _resolveComponent("ModalCancelAppointment")!
  const _component_CreateFeedbackModal = _resolveComponent("CreateFeedbackModal")!
  const _component_ConnectCalendarModal = _resolveComponent("ConnectCalendarModal")!
  const _component_AnsweredFormModal = _resolveComponent("AnsweredFormModal")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, {
        currentPage: `rooms`,
        selectedTabName: _ctx.selectedTabName,
        onCreate: _ctx.createGroup
      }, null, 8, ["selectedTabName", "onCreate"]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_InstantRoomAllSwitcher, { onSwitchAll: _ctx.switchAll }, null, 8, ["onSwitchAll"])
                  ])
                ]),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          _hoisted_10,
          (!_ctx.currentTabRooms)
            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                _createVNode(_component_RoomsLoader)
              ]))
            : (_ctx.currentTabRooms.length == 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                      width: "40",
                      height: "40"
                    }, null, 8, _hoisted_15)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTabRooms, (room, roomindex) => {
                      return (_openBlock(), _createBlock(_component_OneInstantRoom, {
                        class: "mr20",
                        key: `${roomindex}${_ctx.systemUpdatedAt}`,
                        room: room,
                        onChangeActive: _ctx.changeActive
                      }, null, 8, ["room", "onChangeActive"]))
                    }), 128))
                  ]),
                  _hoisted_18
                ]))
        ]),
        _createElementVNode("section", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          (!_ctx.upcomingFixRooms)
            ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
                _createVNode(_component_RoomsLoader)
              ]))
            : (_ctx.upcomingFixRooms.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                      width: "40",
                      height: "40"
                    }, null, 8, _hoisted_26)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingFixRooms, (room, roomindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${roomindex}${_ctx.systemUpdatedAtForSchedule}`
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_OneEventRoomContent, {
                          room: room,
                          class: "mb20 with_white_bg",
                          onClickFormMember: _ctx.clickFormMember,
                          onGoRoom: _ctx.goRoom
                        }, null, 8, ["room", "onClickFormMember", "onGoRoom"]),
                        _hoisted_29
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _hoisted_30
      ])
    ]),
    _createVNode(_component_ModalRoomMembersLink, {
      members: _ctx.members_with_links,
      room: _ctx.selectedRoom
    }, null, 8, ["members", "room"]),
    _createVNode(_component_PublicLinkModal, { room: _ctx.selectedRoom }, null, 8, ["room"]),
    _createVNode(_component_CreateFromDraftModal, {
      room: _ctx.selectedRoom,
      modalType: _ctx.modalType,
      closeDraftModal: _ctx.closeDraftModal,
      userFilter: _ctx.userFilter
    }, null, 8, ["room", "modalType", "closeDraftModal", "userFilter"]),
    _createVNode(_component_GoAvailableScheduleModal),
    _createVNode(_component_ChooseRoomTypeModal, { goRoomSettings: _ctx.goRoomSettings }, null, 8, ["goRoomSettings"]),
    _createVNode(_component_ModalCancelAppointment, {
      selectedMessageRoom: _ctx.selectedRoom,
      appo: _ctx.selectedRoom ? _ctx.selectedRoom.current_appointment : null,
      from: `rooms`,
      onRescheduledRoom: _ctx.rescheduledRoom,
      onCanceledRoom: _ctx.canceledRoom
    }, null, 8, ["selectedMessageRoom", "appo", "onRescheduledRoom", "onCanceledRoom"]),
    _createVNode(_component_CreateFeedbackModal, {
      room: _ctx.selectedRoom,
      member: null
    }, null, 8, ["room"]),
    _createVNode(_component_ConnectCalendarModal),
    _createVNode(_component_AnsweredFormModal, {
      member: _ctx.formMemDetail,
      room: _ctx.selectedRoom
    }, null, 8, ["member", "room"]),
    _createVNode(_component_AlertModal, {
      ref: "AlertModal",
      title: _ctx.alertDic ? _ctx.alertDic.title : ``,
      text: _ctx.alertDic ? _ctx.alertDic.text : ``,
      okButtonName: _ctx.alertDic ? _ctx.alertDic.buttonName : ``,
      eventName: null,
      retValue: _ctx.alertDic ? _ctx.alertDic.retValue : null,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["title", "text", "okButtonName", "retValue", "onClickOK", "onClickCancel"])
  ]))
}